/*
 * @Author: your name
 * @Date: 2021-11-11 13:10:32
 * @LastEditTime: 2022-03-06 22:39:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\components\tabbar\index.js
 */

export default{
    data() {
        return {
        }
    },
    props:{
        name: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: '20px'
        },
    },
    methods: {
        
    },
    created() {
    },
    computed: {
        getIconName() {
            let iconName = this.name
            if(iconName) {
                return 'iconfont icon_' + iconName
            }
            return ''
        }
    }
}